/* eslint-disable */
import React from 'react'
import { scaleLinear, scaleSqrt } from 'd3-scale'
import { hexbin } from 'd3-hexbin'
import { max } from 'd3-array'
import filter from 'lodash/filter'

import { RemoveBadPitchPoints } from '../../Utilities/RemoveBadPoints'
import RunCalculations from '../../Utilities/RunCalculations'
import ColorPalette from '../../Utilities/Colors/Palettes'

import HexLegend from '../../Legend/HexLegend'

export default function HexBin({ settings, chartOptions = {} }) {
    const pitchData = settings.data
    const chartType = chartOptions.type
    const pitcherView = chartOptions.pitcherPerspective

    const x = scaleLinear()
        .range([0, settings.vizWidth])
        .domain(pitcherView ? [4, -4] : [-4, 4])

    let y = scaleLinear().range([settings.vizHeight, 0]).domain([-1, 6])

    if (chartOptions.strikeZone === 'relative') {
        y = scaleLinear().range([settings.vizHeight, 0]).domain([-4, 4])
    }

    const radiusSize = 14

    const hex = hexbin()
        .x((d) => x(d.x))
        .y((d) => y(d.y))
        .radius((radiusSize * settings.vizWidth) / settings.vizWidth - 1)
        .extent([
            [0, 0],
            [settings.vizWidth - 0, settings.vizHeight - 0],
        ])

    const bins = hex(pitchData)
    for (let i = 0; i < bins.length; i++) {
        bins[i].calculations = RunCalculations(bins[i])
    }

    const palette = new ColorPalette({
        type: chartType,
        data: bins,
    })
    const { color } = palette

    const maxCount = max(bins, (d) => d.length)
    let radius = scaleSqrt([0, maxCount * 1.8], [0, hex.radius() * Math.SQRT2])

    if (!chartOptions.scaleRadius) {
        radius = function () {
            return radiusSize
        }
    }

    return (
        <>
            <g id="hexbinChart">
                {bins.map((d, i) => (
                    <path
                        key={`hexPath_${i}`}
                        d={hex.hexagon(radius(d.length), d)}
                        transform={`translate(${d.x},${d.y})`}
                        fill={
                            d
                                ? color(Number(d.calculations[chartType]))
                                : '#000'
                        }
                        stroke="#000"
                        opacity={chartOptions.opacity}
                    />
                ))}
            </g>
            {chartOptions.legend ? (
                <HexLegend
                    settings={settings}
                    hex={hex}
                    color={color}
                    radius={radius}
                    maxCount={maxCount}
                    chartType={chartType}
                    chartOptions={chartOptions}
                />
            ) : null}
        </>
    )
}
